import { useMemo } from "react"

export default function usePagination(data, currentPage = 1, itemsPerPage = 12) {
	const [sliced, totalPages] = useMemo(() => {
		const currPage = Math.max(1, currentPage)
		const totalPages = Math.ceil(data.length / itemsPerPage)
		const lastIndex = currPage * itemsPerPage
		const firstIndex = lastIndex - itemsPerPage
		const sliced = data.slice(firstIndex, lastIndex)
		return [sliced, totalPages]
	}, [data, currentPage, itemsPerPage])

	return [sliced, totalPages]
}

//testing
export function usePagination2(data, currentPage = 1) {
	const currPage = useMemo(() => Math.max(1, currentPage), [currentPage])
	const index = currPage - 1
	return data[index]
}
